/* ============================================================
   zeromode - quantity picker-roll
   Gives the quantity stepper a UIPickerView-style roll: on "+"
   the old number slides up and out while the new number rises
   from below; on "-" it reverses. Only the current number shows.

   Works in the cart, product pages, and the quick-add modal.
   Self-heals: a MutationObserver re-enhances steppers that get
   re-rendered (cart updates) or added (quick-add opens).
   ============================================================ */
(function () {
  'use strict';

  var REDUCED = window.matchMedia &&
    window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var DURATION = 280;
  var EASING = 'cubic-bezier(0.22, 1, 0.36, 1)';

  function buildNum(value, font) {
    var span = document.createElement('span');
    span.className = 'zm-qty__num';
    span.textContent = value;
    if (font) {
      span.style.font = font.font;
      span.style.fontSize = font.size;
      span.style.fontWeight = font.weight;
      span.style.fontFamily = font.family;
      span.style.lineHeight = font.line;
    }
    return span;
  }

  function enhance(input) {
    if (!input || input.zmRoll) return;
    var selector = input.closest('.quantity-selector');
    if (!selector) return;

    var cs = window.getComputedStyle(input);
    var font = {
      font: cs.font,
      size: cs.fontSize,
      weight: cs.fontWeight,
      family: cs.fontFamily,
      line: cs.lineHeight
    };

    // Wrap the input so the roll overlay can sit on top of it.
    var wrap = document.createElement('span');
    wrap.className = 'zm-qty zm-qty--ready';
    input.parentNode.insertBefore(wrap, input);
    wrap.appendChild(input);

    var roll = document.createElement('span');
    roll.className = 'zm-qty__roll';
    wrap.appendChild(roll);

    var current = input.value;
    var numEl = buildNum(current, font);
    roll.appendChild(numEl);

    var api = {
      current: current,
      set: function (value, dir) {
        value = String(value);
        if (value === this.current) return;
        if (dir === 0) dir = Number(value) >= Number(this.current) ? 1 : -1;

        var oldEl = numEl;
        var newEl = buildNum(value, font);
        roll.appendChild(newEl);
        numEl = newEl;
        this.current = value;

        if (REDUCED || typeof newEl.animate !== 'function') {
          oldEl.remove();
          return;
        }

        var enter = dir > 0 ? '100%' : '-100%';
        var exit = dir > 0 ? '-100%' : '100%';

        oldEl.animate(
          [
            { transform: 'translateY(0)', opacity: 1 },
            { transform: 'translateY(' + exit + ')', opacity: 0 }
          ],
          { duration: DURATION, easing: EASING, fill: 'forwards' }
        );
        var anim = newEl.animate(
          [
            { transform: 'translateY(' + enter + ')', opacity: 0 },
            { transform: 'translateY(0)', opacity: 1 }
          ],
          { duration: DURATION, easing: EASING, fill: 'forwards' }
        );
        anim.onfinish = function () {
          if (oldEl && oldEl.parentNode) oldEl.remove();
        };
      }
    };

    input.zmRoll = api;
    return api;
  }

  // Read the (possibly just-updated) value and roll to it.
  function rollTo(input, dirHint) {
    if (!input || !input.zmRoll) return;
    input.zmRoll.set(input.value, dirHint || 0);
  }

  // +/- clicks: the theme updates the value first, so we read it next frame.
  document.addEventListener('click', function (event) {
    var btn = event.target.closest('.quantity-plus, .quantity-minus, [name="plus"], [name="minus"]');
    if (!btn) return;
    var selector = btn.closest('.quantity-selector');
    if (!selector) return;
    var input = selector.querySelector('input[type="number"]');
    if (!input) return;
    enhance(input);
    var dir = btn.matches('.quantity-minus, [name="minus"]') ? -1 : 1;
    requestAnimationFrame(function () {
      requestAnimationFrame(function () { rollTo(input, dir); });
    });
  });

  // Manual typing: fires on blur/commit.
  document.addEventListener('change', function (event) {
    var input = event.target;
    if (!input.matches || !input.matches('input[type="number"]')) return;
    if (!input.closest('.quantity-selector')) return;
    enhance(input);
    rollTo(input, 0);
  });

  function scan(root) {
    (root || document)
      .querySelectorAll('.quantity-selector input[type="number"]')
      .forEach(enhance);
  }

  function init() { scan(document); }

  if (document.readyState !== 'loading') {
    init();
  } else {
    document.addEventListener('DOMContentLoaded', init);
  }

  // Re-enhance steppers added or replaced by cart updates / quick-add.
  var observer = new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) {
      var added = mutations[i].addedNodes;
      for (var j = 0; j < added.length; j++) {
        var node = added[j];
        if (node.nodeType !== 1) continue;
        if (node.matches && node.matches('input[type="number"]')) {
          enhance(node);
        } else if (node.querySelectorAll) {
          scan(node);
        }
      }
    }
  });
  observer.observe(document.body, { childList: true, subtree: true });

  document.addEventListener('shopify:section:load', function (event) {
    scan(event.target || document);
  });
})();
